import { jsonApiVuex } from '@common/store/json-api-vuex';
const getters = {
  isBranch(state) {
    return state.entity?.parent_id != null;
  },
  containerName(state) {
    return state.entity?.name;
  },
  containerNameEncoded(state) {
    // Remove accents from characters (unaccent function)
    let text = state.entity?.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Convert to lowercase
    text = text.toLowerCase();

    // Remove all non-word characters
    text = text.replace(/\W/g, ' ');

    // Replace spaces with dashes and handle further stripping
    text = text
      .replace(/[^a-z0-9\/]+/g, '-')
      .replace(/([a-z\d])([A-Z])/g, '$1_$2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
      .replace(/::/g, '/');

    // Trim any leading or trailing dashes
    return text.replace(/^-+|-+$/g, '');
  },
};
export const tmsWebContainer = jsonApiVuex('tms/web-container', { getters }, {});
